import { StageElement } from "../../../types";
import type { ViewerDeviceRuntime } from "../../../types";
import ImageElementViewer from "./viewer";
import Layout from "./layout";
import { Media } from "@bronte/viewer";

type ImageElementProps = {
  element: StageElement;
  readOnly?: boolean;
  onMediaClick?: (data: Media) => void;
  viewerDevice?: ViewerDeviceRuntime;
};

const ImageElement = ({
  element,
  readOnly = true,
  onMediaClick,
  viewerDevice,
}: ImageElementProps) => {
  return (
    <Layout element={element}>
      {readOnly ? (
        <ImageElementViewer
          element={element}
          onMediaClick={onMediaClick}
          viewerDevice={viewerDevice}
        />
      ) : null}
    </Layout>
  );
};

export default ImageElement;
